import React from "react";
import SEO from "../components/SEO";

const places = [
  {
    id: 1,
    name: "Akshardham",
    location: "New Delhi",
    category: "Spiritual",
    distance: "45 km",

    description:
      "One of India's most iconic cultural and spiritual landmarks, Akshardham Temple showcases breathtaking architecture, intricate carvings, musical fountains, and immersive exhibitions depicting Indian heritage and spirituality. The beautifully landscaped gardens and evening light show make it a must-visit destination near Greater Noida.",

    image: "/nclc-2026/assets/download.webp",
  },
  {
    id: 2,
    name: "Buddh International Circuit",
    location: "Greater Noida",
    category: "Adventure",
    distance: "12 km",

    description:
      "India's premier Formula 1 racing circuit known for its world-class track design, high-speed corners, and thrilling motorsport events. Spread across a massive area in Greater Noida, the circuit attracts racing enthusiasts, superbike events, and automobile showcases throughout the year.",

    image:
      "https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=600&q=80",
  },

  {
    id: 4,
    name: "The Grand Venice Mall",
    location: "Greater Noida",
    category: "Shopping",
    distance: "10 km",

    description:
      "A unique Venice-themed shopping and entertainment destination famous for its indoor canal, gondola rides, Italian-inspired architecture, gaming zones, multiplex, and luxury shopping outlets. The mall combines leisure, dining, and entertainment, making it one of Greater Noida's most popular hangout spots.",

    image: "/nclc-2026/assets/the-grand-venice-mall.webp",
  },
  {
    id: 3,
    name: "Qutub Minar",
    location: "Delhi",
    category: "Historical",
    distance: "48 km",

    description:
      "Qutub Minar is one of the most famous historical monuments in India and a symbol of Delhi's rich architectural heritage. Located in Mehrauli, South Delhi, it is the tallest brick minaret in the world, standing at approximately 72.5 meters (238 feet).The Qutub Minar was originally built as a victory tower and a minaret from which the call to prayer was given. Despite being over 800 years old, it remains one of India's most visited historical monuments and a masterpiece of medieval architecture.",

    image: "/nclc-2026/assets/qutub-minarr.webp",
  },

  {
    id: 5,
    name: "Taj Mahal and Agra Fort",
    location: "Agra, Uttar Pradesh",
    category: "Historical",
    distance: "210 km",

    description:
      "A perfect historical getaway from Greater Noida, featuring the world-famous Taj Mahal — a symbol of eternal love built by Mughal Emperor Shah Jahan — along with the majestic Agra Fort, a UNESCO World Heritage Site showcasing stunning Mughal architecture, royal courtyards, and grand palaces.",

    image: "/nclc-2026/assets/taj-mahal.webp",
  },
  {
    id: 6,
    name: "Prem Mandir Vrindavan",
    location: "Uttar Pradesh",
    category: "Religious",
    distance: "160 km",

    description: ` Prem Mandir, Vrindavan is a magnificent white marble temple dedicated to Lord Radha Krishna and Lord Sita Ram, located in the spiritual town of Vrindavan, Uttar Pradesh. Built by Jagadguru Kripalu Maharaj, the temple is renowned for its stunning architecture, intricate carvings, illuminated fountains, and beautifully landscaped gardens.

Prem Mandir becomes especially mesmerizing in the evening during the musical light and fountain show, attracting thousands of visitors and devotees every day. It is considered one of the most beautiful and iconic spiritual destinations in Vrindavan.`,

    image: "/nclc-2026/assets/prem-mandir.webp",
  },
];

const Tourism = () => {
  return (
    <div className="min-h-screen pt-20 bg-[#faf8f4] text-[#2c2519] font-serif">
      <SEO title="Tourism" />
      <div className="max-w-6xl mx-auto px-6 py-10">
        {places.map((place, index) => (
          <div
            key={place.id}
            className={`flex flex-col md:flex-row ${
              index % 2 !== 0 ? "md:flex-row-reverse" : ""
            } mb-8 overflow-hidden rounded-xl border border-[#e8e0d0] bg-white shadow-md`}
          >
            {/* Image Section */}
            <div className="relative w-full md:w-[260px] md:min-w-[260px]">
              <img
                src={place.image}
                alt={place.name}
                className="h-[240px] w-full object-cover"
              />

              <div
                className={`absolute top-3 ${
                  index % 2 === 0 ? "left-3" : "right-3"
                } rounded-full bg-gray-700 px-3 py-1 text-[11px] font-semibold tracking-wide text-white`}
              >
                {place.category}
              </div>
            </div>

            {/* Content Section */}
            <div className="flex flex-1 flex-col justify-center p-6">
              <div className="mb-2 flex items-start justify-between gap-4">
                <h3 className="text-2xl font-bold leading-snug text-gray-800">
                  {place.name}
                </h3>

                <span className="mt-1 whitespace-nowrap text-xs font-semibold text-[#b08968]">
                  {place.distance}
                </span>
              </div>

              <p className="mb-4 text-sm tracking-wide text-[#7a6e5a]">
                📍 {place.location}
              </p>

              <p className="text-[15px] leading-8 text-[#3a3028]">
                {place.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Tourism;

